import { trackEvent } from 'dibs-tracking';

export const ATTRIBUTE_SEARCH_CORRECTION = 'data-static-tracking-search-correction';
export const ATTRIBUTE_SEARCH_AUTO_CORRECT = 'data-static-tracking-auto-correction';

export const trackSearchCorrectionClick = (term: string, overrideType: string): void =>
    trackEvent({
        label: term,
        category: 'search suggestion text',
        action: `${overrideType} override clicked`,
    });

export const trackAutoCorrectClick = (correctedTerm: string, originalTerm: string): void =>
    trackEvent({
        category: 'search suggestion text',
        action: 'override spelling autocorrect',
        label: `${correctedTerm}|${originalTerm}`,
    });

export const trackAutoCorrectView = (correctedTerm: string, originalTerm: string): void =>
    trackEvent({
        category: 'search suggestion text',
        action: 'spelling autocorrect',
        label: `${correctedTerm}|${originalTerm}`,
    });

export type SearchCorrectionTrackingData = {
    term: string;
    originalTerm: string;
    overrideType: string;
};
export type SearchAutoCorrectionTrackingData = {
    term: string;
    originalTerm: string;
};

export function encodeForceSearchTrackingData<T>(data: T): string {
    return JSON.stringify(data);
}
